import { englishFinanceMessages } from "./englishFinanceMessages";
import { englishPwaMessages } from "./englishPwaMessages";

export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      team_name: "Company / team name",
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_team:
          "Create your account and your team. You can invite your colleagues afterwards.",
        team_created: "Your account and your team are ready",
        have_account: "Already have an account? Sign in",
        no_account: "No account yet? Create your team",
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      no_matching_item: "No matching item found.",
      no_results_found: "No results found.",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      welcome: {
        title: "Your CRM Starter Kit",
        template:
          "is a template designed to help you quickly build your own CRM.",
        demo: "This demo runs on a mock API, so you can explore and modify the data. It resets on reload. The full version uses Supabase for the backend.",
        powered_by: "Powered by",
        open_source:
          ", Atomic CRM is fully open-source. You can find the code at",
      },
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
    team: {
      title: "Team",
      subtitle: "Name, members and invitations",
      name: "Team name",
      members: "%{smart_count} member |||| %{smart_count} members",
      invite: "Invite member",
      invite_help:
        "Members get an e-mail to join the team and only ever see its data.",
      role_admin: "Admin",
      role_member: "Member",
      disabled: "Disabled",
      renamed: "Team renamed",
    },
    finance: englishFinanceMessages,
    pwa: englishPwaMessages,
    operations: {
      title: "Operations",
      load_more: "Load more",
      tabs: {
        crm: "CRM",
        tasks: "Tasks",
      },
      priorities: {
        low: "Low",
        medium: "Medium",
        high: "High",
        urgent: "Urgent",
      },
      pipelines: {
        label: "Pipeline",
        create: "New pipeline",
        rename: "Rename pipeline",
        delete: "Delete pipeline",
        delete_title: "Delete the pipeline %{name}?",
        delete_description:
          "Its stages and cards are removed from Operations. Contacts, negotiations and tasks are kept.",
        name: "Pipeline name",
        default_name: "Sales",
        with_default_stages: "Start with the default stages",
        created: "Pipeline created",
        updated: "Pipeline renamed",
        deleted: "Pipeline deleted",
        empty_title: "No pipeline yet",
        empty:
          "Create your first pipeline to follow your contacts in a kanban.",
        default_stages: {
          new_lead: "New lead",
          contacted: "Contacted",
          proposal: "Proposal",
          negotiation: "Negotiation",
          closed: "Closed",
        },
      },
      stages: {
        add: "Add stage",
        name: "Stage name",
        rename: "Rename",
        move_left: "Move left",
        move_right: "Move right",
        add_after: "Add stage after",
        delete: "Delete stage",
        delete_title: "Delete the stage %{name}?",
        delete_empty: "This stage is empty and will be removed.",
        delete_with_cards:
          "This stage has %{smart_count} card. Choose where to move it first. |||| This stage has %{smart_count} cards. Choose where to move them first.",
        move_cards_to: "Move the cards to",
        created: "Stage added",
        updated: "Stage updated",
        deleted: "Stage deleted",
        last_stage: "A pipeline needs at least one stage",
        actions: "Stage actions",
        drop_here: "Drop cards here",
      },
      cards: {
        add: "New card",
        add_to_stage: "Add a card to %{stage}",
        create_title: "New card",
        created: "Card created",
        created_partially:
          "Card created, but %{smart_count} item could not be saved |||| Card created, but %{smart_count} items could not be saved",
        updated: "Card updated",
        moved: "Card moved",
        remove: "Remove from pipeline",
        remove_title: "Remove %{name} from the pipeline?",
        remove_description:
          "The card leaves this pipeline. The contact, negotiations, tasks and notes are kept.",
        removed: "Card removed from the pipeline",
        open_contact: "Open contact page",
        in_stage_since: "In this stage since %{date}",
        open_tasks: "%{smart_count} open task |||| %{smart_count} open tasks",
        overdue_tasks: "Has overdue tasks",
        unnamed: "(no name)",
        create: "Create card",
      },
      fields: {
        name: "Name",
        tags: "Tags",
        email: "E-mail",
        phone: "Phone",
        assignee: "Assigned to",
        source: "Source",
        priority: "Priority",
        stage: "Stage",
      },
      placeholders: {
        name: "Contact or company name",
        email: "name@company.com",
        phone: "+55 11 99999-9999",
        search_tags: "Search or create a tag…",
        search_source: "Search or create a source…",
        empty_value: "Click to add",
      },
      combobox: {
        create: 'Create "%{name}"',
        no_results: "Nothing found",
        none: "None",
        remove: "Remove %{name}",
        used: "%{smart_count} use |||| %{smart_count} uses",
      },
      deals: {
        title: "Negotiations",
        add: "New negotiation",
        name: "Deal name",
        amount: "Offer",
        description: "Description",
        created: "Negotiation added",
        deleted: "Negotiation deleted",
        delete: "Delete negotiation",
        empty: "No negotiation yet",
        total: "Total",
      },
      documents: {
        title: "Documents",
        attach: "Attach document",
        deleted: "Document deleted",
        delete: "Delete document",
        added: "Document attached",
        empty: "No document yet",
      },
      notes: {
        title: "Notes",
        add: "Add note",
        placeholder: "Write a note…",
        created: "Note added",
        deleted: "Note deleted",
        delete: "Delete note",
        empty: "No note yet",
      },
      tasks: {
        title: "Tasks",
        add: "Add task",
        create: "New task",
        edit: "Edit task",
        delete: "Delete task",
        created: "Task created",
        updated: "Task updated",
        deleted: "Task deleted",
        moved: "Task moved",
        empty: "No task yet",
        empty_filtered: "No task matches the filters",
        count: "%{smart_count} task |||| %{smart_count} tasks",
        free: "No card",
        no_due: "No due date",
        overdue: "Overdue",
        hours: "%{spent}h of %{estimated}h",
        view_board: "Board",
        view_list: "List",
        statuses: {
          todo: "To do",
          doing: "Doing",
          blocked: "Blocked",
          done: "Done",
        },
        fields: {
          title: "Title",
          description: "Description",
          status: "Status",
          priority: "Priority",
          assignee: "Assigned to",
          card: "Card",
          due_date: "Due date",
          estimated_hours: "Estimated hours",
          spent_hours: "Spent hours",
          attachments: "Documents",
          created_at: "Created",
        },
      },
      filters: {
        search: "Search…",
        user: "User",
        all_users: "All users",
        mine: "Only mine",
        tags: "Tags",
        source: "Source",
        priority: "Priority",
        status: "Status",
        card: "Card",
        due: "Due date",
        any: "Any",
        clear: "Clear filters",
        active: "%{smart_count} filter |||| %{smart_count} filters",
        dues: {
          overdue: "Overdue",
          today: "Due today",
          week: "Due this week",
          none: "No due date",
        },
      },
    },
    personal: {
      title: "Personal",
      subtitle: "Your personal growth space",
      calendar: {
        today: "Today",
        previous_month: "Previous month",
        next_month: "Next month",
      },
      timeline: {
        title: "Schedule",
        hint: "Click on a time slot to add an event",
      },
      events: {
        create: "New event",
        edit: "Edit event",
        delete: "Delete event",
        created: "Event added",
        updated: "Event updated",
        deleted: "Event deleted",
        invalid_range: "The end must be after the start",
        fields: {
          title: "Title",
          start_at: "Starts",
          end_at: "Ends",
          description: "Description",
          color: "Color",
        },
      },
      todos: {
        title: "To-do",
        add: "Add a to-do",
        create: "New to-do",
        edit: "Edit to-do",
        delete: "Delete to-do",
        mark_done: "Mark as done",
        created: "To-do added",
        updated: "To-do updated",
        deleted: "To-do deleted",
        completed: "To-do completed",
        next_scheduled: "Done! Next one scheduled for %{date}",
        empty: "Nothing to do. Add a to-do with the + button.",
        repeats: "Repeats",
        groups: {
          overdue: "Overdue",
          today: "Today",
          upcoming: "Upcoming",
        },
        fields: {
          title: "Title",
          description: "Description",
          due_date: "Finish by",
          reminder: "Remind me",
          remind_at: "Reminder date and time",
          recurrence: "Repeat",
          recurrence_interval: "Every how many days?",
        },
        reminders: {
          none: "Don't remind me",
          day_start: "On the day, at 9 AM",
          end_of_day_1h: "1 hour before the day ends (11 PM)",
          end_of_day_3h: "3 hours before the day ends (9 PM)",
          day_before: "1 day before (9 AM)",
          week_before: "1 week before (9 AM)",
          custom: "Custom…",
        },
        reminder_hint: "Reminder on %{date}",
        reminder_in_past: "This reminder time has already passed",
        recurrences: {
          none: "Does not repeat",
          daily: "Daily",
          weekdays: "Every weekday (Mon–Fri)",
          weekly: "Weekly",
          monthly: "Monthly",
          yearly: "Yearly",
          custom: "Custom…",
        },
        recurrence_hints: {
          daily: "Repeats every day",
          weekdays: "Repeats Monday to Friday",
          weekly: "Repeats every %{weekday}",
          monthly: "Repeats on day %{day} of every month",
          yearly: "Repeats every year on %{date}",
          custom:
            "Repeats every %{smart_count} day |||| Repeats every %{smart_count} days",
        },
      },
      reminders: {
        enable: "Enable notifications",
        enabled: "Notifications on",
        denied:
          "Notifications are blocked. Allow them in your browser's site settings to receive reminders.",
        unsupported: "Your browser doesn't support notifications.",
        hint: "Reminders appear while the CRM is open in a browser tab.",
        notification_title: "Reminder: %{title}",
        due: "Due %{date}",
      },
      life_wheel: {
        title: "Wheel of Life",
        subtitle: "PRO methodology",
        fill: "Fill in my assessment",
        edit: "Edit assessment",
        empty:
          "Rate 12 areas of your life to see where you are today and where you want to be in 1 year.",
        updated_at: "Last updated %{date}",
        area: "Area",
        current: "Current",
        target: "In 1 year",
        dialog_description:
          "Rate each area from 0 to 10: how you see yourself today, and where you want to be in 1 year. Hover over an area to learn more about it.",
        zero_warning:
          "An area with 0 for current and 0 for in 1 year will not appear in the chart.",
        min_topics: "Fill in at least 3 areas to see the chart.",
        saved: "Assessment saved",
        invalid_score: "Enter a number from 0 to 10",
        topics: {
          emotional: {
            name: "Emotional",
            description:
              "How you handle your feelings, stress and self-esteem.",
          },
          spiritual: {
            name: "Spiritual",
            description:
              "Your connection with faith, purpose and the values that give meaning to your life.",
          },
          intellectual: {
            name: "Intellectual",
            description:
              "Continuous learning, reading and developing your thinking.",
          },
          serving: {
            name: "Serving",
            description:
              "How much you contribute to others and to your community: volunteering, helping, giving back.",
          },
          relatives: {
            name: "Relatives",
            description:
              "Your relationship with your extended family: parents, siblings, uncles, cousins.",
          },
          family: {
            name: "Family",
            description:
              "Your household: the time and care you give to your children and the people you live with.",
          },
          marital: {
            name: "Marital",
            description:
              "The quality of your relationship with your spouse or partner.",
          },
          health: {
            name: "Health",
            description:
              "Your body and energy: sleep, nutrition, exercise and medical care.",
          },
          professional: {
            name: "Professional",
            description: "Satisfaction and growth in your work and career.",
          },
          academic: {
            name: "Academic",
            description:
              "Formal education: courses, degrees and certifications.",
          },
          financial: {
            name: "Financial",
            description:
              "Control over your money: income, expenses, savings and investments.",
          },
          social: {
            name: "Social",
            description: "Friendships, networking and your social life.",
          },
        },
      },
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
